<template>
    <div class="give-score">
        <div class="font-size18 font-medium">考生得分</div>
        <div class="xy-start score-box">
            得分：
            <el-input-number v-model="cScore" controls-position="right"
                             style="width: 130px"
                             :disabled="disable"
                             :max="maxScore"
                             :min="0"
            ></el-input-number>
            <span style="margin-left: 10px">分</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "GiveScore",
    props: {
        score: {},
        disable: {
            type: Boolean,
            default: false
        },
        maxScore: {
            type: Number,
            default: 999
        }
    },
    model: {
        prop: "score",
        event: "change"
    },
    data() {
        return {
            cScore: ""
        }
    },
    created() {
        this.cScore = this.score;
    },
    watch: {
        cScore(newValue, oldValue) {
            this.$emit("change", newValue)
        },
        score(newValue) {
            if (this.cScore !== newValue) this.cScore = newValue;
        }
    },
}
</script>

<style scoped lang="less">
.give-score {
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #E5E8EC;
    min-height: 100px;
    padding: 20px;
    box-sizing: border-box;
    font-size: 14px;
    margin-left: 20px;

    .score-box {
        align-items: baseline;
        margin: 30px 40px;
    }
}
</style>
